import { render } from "./ChecklistItem.vue?vue&type=template&id=09b3d03c"
import script from "./ChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistItem.vue?vue&type=script&lang=js"
script.render = render

export default script